module.exports = __webpack_public_path__ + "img/1_1-edificabile.4b7d3112.png";